import { z } from "zod";

export const SpatialRefSysBaseSchema = z.object({
  srid: z.number().int(),
  auth_name: z.string().max(256, "Le nom d'autorité ne peut pas dépasser 256 caractères").nullable().optional(),
  auth_srid: z.number().int().nullable().optional(),
  srtext: z.string().max(2048, "Le texte SR ne peut pas dépasser 2048 caractères").nullable().optional(),
  proj4text: z.string().max(2048, "Le texte Proj4 ne peut pas dépasser 2048 caractères").nullable().optional(),
});

export const SpatialRefSysSchema = SpatialRefSysBaseSchema;

export const SpatialRefSysCreateSchema = SpatialRefSysBaseSchema.pick({
  srid: true,
  auth_name: true,
  auth_srid: true,
  srtext: true,
  proj4text: true,
});

export const SpatialRefSysUpdateSchema = z.object({
  srid: z.number().int(),
  auth_name: z.string().max(256, "Le nom d'autorité ne peut pas dépasser 256 caractères").nullable().optional(),
  auth_srid: z.number().int().nullable().optional(),
  srtext: z.string().max(2048, "Le texte SR ne peut pas dépasser 2048 caractères").nullable().optional(),
  proj4text: z.string().max(2048, "Le texte Proj4 ne peut pas dépasser 2048 caractères").nullable().optional(),
});

export const SpatialRefSysListResponseSchema = z.object({
  data: z.array(SpatialRefSysSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export const SpatialRefSysResponseSchema = z.object({
  data: SpatialRefSysSchema,
  message: z.string().optional(),
});

export const SpatialRefSysSelectSchema = z.object({
  srid: z.number().int().optional(),
  auth_name: z.string().optional(),
  auth_srid: z.number().int().optional(),
});

export type SpatialRefSys = z.infer<typeof SpatialRefSysSchema>;
export type SpatialRefSysCreateInput = z.infer<typeof SpatialRefSysCreateSchema>;
export type SpatialRefSysUpdateInput = z.infer<typeof SpatialRefSysUpdateSchema>;
export type SpatialRefSysSelectInput = z.infer<typeof SpatialRefSysSelectSchema>;

// Form-specific types for frontend
export type SpatialRefSysFormData = SpatialRefSysCreateInput;

export type SpatialRefSysEditFormData = Omit<SpatialRefSysUpdateInput, 'srid'>;

// Utility types for different UI states
export type SpatialRefSysDisplayItem = Pick<SpatialRefSys, 'srid' | 'auth_name' | 'auth_srid'>;
export type SpatialRefSysSelectOption = Pick<SpatialRefSys, 'srid' | 'auth_name'>;
export type SpatialRefSysTableItem = Pick<SpatialRefSys, 'srid' | 'auth_name' | 'auth_srid' | 'srtext' | 'proj4text'>;

export type SpatialRefSysResponse = z.infer<typeof SpatialRefSysResponseSchema>;
export type SpatialRefSysListResponse = z.infer<typeof SpatialRefSysListResponseSchema>;

export const validateSpatialRefSysCreate = (data: unknown) => {
  return SpatialRefSysCreateSchema.safeParse(data);
};

export const validateSpatialRefSysUpdate = (data: unknown) => {
  return SpatialRefSysUpdateSchema.omit({ srid: true }).safeParse(data);
};

export const validateSpatialRefSysSelect = (data: unknown) => {
  return SpatialRefSysSelectSchema.safeParse(data);
};
